import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-car-plate",
  templateUrl: "car-plate.component.html",
})
export class CarPlateComponent {
  @Input() digits: string;
  @Input() letters: string;
  @Output() carPlateChange = new EventEmitter<{
    digits: string;
    letters: string;
  }>();

  onChange() {
    this.carPlateChange.emit({ digits: this.digits, letters: this.letters });
  }
}
